import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "common/components/Button/Button"
import Modal from "common/components/Modal/Modal"
import { AppContext } from "common/context/WithAppWrapper"
import { formatCurrency } from "common/utils/currency"
import { newDocumentoSelectorDoc } from "features/Crear/redux/slices/newDocumentoSlice"
import ArticulosFilter from "features/Inventario/components/ArticulosFilter/ArticulosFilter"
import { useSelector } from "hooks/useSelector"
import { Badge } from "primereact/badge"
import { useContext, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import useNewProducts from "../../hooks/useNewProducts"
import ArticulosList from "./ArticulosList"
import ArticulosSelected from "./ArticulosSelected"
import "./index.scss"

const NewProducts = ({
  hide,
  initialEmpresa,
  isLibrado,
  title,
  sinValorar,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const lastArticuloRef = useRef()
  const [showWithGrid, setShowWithGrid] = useState(true)
  // @ts-expect-error TS(2339): Property 'settings' does not exist on type 'unknow...
  const { settings } = useContext(AppContext)

  const {
    articulos,
    toggleShowModalArticulosSelected,
    showModalArticulosSelected,
    precioTotal,
    categorias,
    cantidadArticulos,
    articulosIdSelected,
    loadingArticulos,
    loadingMoreArticulos,
    handleGenerarPresupuesto,
    agregarCantidad,
    handleChangeCantidad,
    addArticulo,
    getArticulos,
    removeArticulo,
  } = useNewProducts({
    hide,
    initialEmpresa,
    isLibrado,
  })

  const { librador, librado, documentosAsociados, isDocumentToContact } =
    useSelector(newDocumentoSelectorDoc)

  useEffect(() => {
    const checkWindowWidth = () => {
      if (window.innerWidth <= 910) {
        setShowWithGrid(true)
      }
    }

    window.addEventListener("resize", checkWindowWidth)

    return () => window.removeEventListener("resize", checkWindowWidth)
  }, [])

  useEffect(() => {
    documentosAsociados?.length > 0 && handleGenerarPresupuesto()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentosAsociados])

  return (
    <div className='w-100'>
      <div className='row justify-content-center'>
        <div className='col-12 col-lg-9'>
          <div className='w-full m-0 row align-items-center'>
            <div className='p-0 col-md-12 col-lg-6 d-flex justify-content-start'>
              <span
                className='text-truncate'
                title={
                  initialEmpresa?.razonSocial || isDocumentToContact
                    ? librador?.razonSocial
                    : librado?.razonSocial || ""
                }
              >
                {`${t("crear.facturaRec.createLabel")}${title} 
             ${
               initialEmpresa?.razonSocial || isDocumentToContact
                 ? librador?.razonSocial
                 : librado?.razonSocial || ""
             }   
                `}
              </span>
            </div>

            <div className='p-0 col-md-12 col-lg-6 justify-content-lg-end d-flex align-items-center justify-content-sm-between'>
              {!sinValorar && (
                <span className='mr-4'>
                  {t("crear.facturaRec.totalPriceLabel")}
                  <b>{formatCurrency(precioTotal)}</b>
                </span>
              )}

              <div className='d-flex'>
                <Button
                  onClick={toggleShowModalArticulosSelected}
                  className='mr-3 raised icon btn-cart-count'
                >
                  <Badge
                    style={{
                      backgroundColor: settings.primary,
                      color: "white",
                    }}
                    value={cantidadArticulos}
                  />
                  <FontAwesomeIcon
                    icon={["fal", "cart-shopping"]}
                    className=' p-overlay-badge cart-icon'
                  />
                </Button>

                <Button
                  className='!tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none'
                  onClick={handleGenerarPresupuesto}
                >
                  {!articulos.length
                    ? t("crear.facturaRec.generateLabel")
                    : `${t("crear.facturaRec.generateLabel")}${title}`}
                </Button>
              </div>
            </div>
          </div>

          <ArticulosFilter
            // @ts-expect-error TS(2322): Type '{ showDisplayModes: true; categorias: never[...
            showDisplayModes
            categorias={categorias}
            showDisplaysMode={false}
            ref={lastArticuloRef}
            onDisplayWithGridMode={setShowWithGrid}
            onFilter={getArticulos}
          />

          <ArticulosList
            // @ts-expect-error TS(2322): Type '{ articulos: never[]; articulosIdSelected: a...
            articulos={articulos}
            articulosIdSelected={articulosIdSelected}
            addArticulo={addArticulo}
            handleChangeCantidad={handleChangeCantidad}
            agregarCantidad={agregarCantidad}
            title={title}
            sinValorar={sinValorar}
            itemsLayout={!showWithGrid}
            loading={loadingArticulos}
            loadingMore={loadingMoreArticulos}
            ref={lastArticuloRef}
            generarPresupuesto={handleGenerarPresupuesto}
          />
        </div>
      </div>

      <Modal
        className='modalWithoutPadding'
        header={
          <span className='d-flex align-items-center'>
            <FontAwesomeIcon
              className='mr-2 icon-size-lg'
              icon={["fal", "cart-shopping"]}
            />{" "}
            {t("crear.facturaRec.selectedArticles")}
          </span>
        }
        visible={showModalArticulosSelected}
        onHide={toggleShowModalArticulosSelected}
      >
        <ArticulosSelected
          title={title}
          sinValorar={sinValorar}
          agregarCantidad={agregarCantidad}
          setCantidad={handleChangeCantidad}
          removeArticulo={removeArticulo}
          handleGenerarPresupuesto={handleGenerarPresupuesto}
        />
      </Modal>
    </div>
  )
}

export default NewProducts
